/*
 * Pagination des groupes de COLLECTION de la page de résultats (agenda,
 * médiathèque, actualités), par 6 cartes.
 *
 * Elle est CÔTÉ CLIENT, et c'est un choix : ces groupes viennent du payload de
 * la page, déjà complet (la requête du page-type est plafonnée). Les paginer
 * côté serveur imposerait un paramètre d'URL par collection, qui viendrait se
 * mêler au `start` de la pagination de l'API — trois compteurs indépendants
 * dans la même adresse, pour des données déjà chargées.
 *
 * Le bloc « Pages » de l'API garde donc SA pagination serveur : elle porte sur
 * un jeu qui n'est pas dans la page.
 *
 * Sans JavaScript, toutes les cartes restent affichées : le module ne masque
 * qu'après s'être exécuté. C'est une amélioration progressive, jamais une
 * condition d'accès au contenu.
 */

const PAR_PAGE = 6;

function texteAnnonce(section, page, total) {
    const titre = section.querySelector('h2');
    const nom = titre ? titre.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : '';
    return `${nom} : page ${page} sur ${total}`;
}

function construirePager(section, ul, cartes) {
    const totalPages = Math.ceil(cartes.length / PAR_PAGE);
    let courante = 1;

    const nav = document.createElement('nav');
    nav.className = 'search-pager search-pager--collection';
    const titre = section.querySelector('h2');
    const nom = titre ? titre.textContent.replace(/\s*\(\d+\)\s*$/, '').trim() : '';
    nav.setAttribute('aria-label', `Pagination — ${nom}`);

    const cotePrev = document.createElement('div');
    cotePrev.className = 'search-pager__side search-pager__side--prev';
    const ol = document.createElement('ol');
    ol.className = 'search-pager__pages list-unstyled';
    const coteNext = document.createElement('div');
    coteNext.className = 'search-pager__side search-pager__side--next';

    // Les deux côtés sont TOUJOURS rendus, même vides : sinon les numéros se
    // décalent vers la gauche sur la première page.
    nav.append(cotePrev, ol, coteNext);

    // Région d'annonce : un changement de page ne recharge rien, il faut donc
    // le dire aux technologies d'assistance.
    const annonce = document.createElement('p');
    annonce.className = 'visually-hidden';
    annonce.setAttribute('role', 'status');
    nav.appendChild(annonce);

    const boutonCote = (libelle, delta, rel) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'btnsecondary no-decoration-hover ff-main pl-20 pr-20 d-flex justify-content-center align-items-center';
        b.textContent = libelle;
        b.setAttribute('rel', rel);
        b.addEventListener('click', () => aller(courante + delta));
        return b;
    };

    const rendre = () => {
        cartes.forEach((li, i) => {
            const dedans = Math.floor(i / PAR_PAGE) + 1 === courante;
            li.hidden = !dedans;
        });

        cotePrev.replaceChildren();
        coteNext.replaceChildren();
        ol.replaceChildren();

        if (courante > 1) cotePrev.appendChild(boutonCote('Page précédente', -1, 'prev'));
        if (courante < totalPages) coteNext.appendChild(boutonCote('Page suivante', +1, 'next'));

        for (let p = 1; p <= totalPages; p++) {
            const li = document.createElement('li');
            li.className = 'search-pager__page';
            if (p === courante) {
                const span = document.createElement('span');
                span.className = 'is-current';
                span.setAttribute('aria-current', 'page');
                span.textContent = String(p);
                li.appendChild(span);
            } else {
                const b = document.createElement('button');
                b.type = 'button';
                b.textContent = String(p);
                b.addEventListener('click', () => aller(p));
                li.appendChild(b);
            }
            ol.appendChild(li);
        }

        annonce.textContent = texteAnnonce(section, courante, totalPages);
    };

    const aller = (p) => {
        if (p < 1 || p > totalPages || p === courante) return;
        courante = p;
        rendre();
        // Ramener le regard ET le focus en tête du groupe : sans quoi, après un
        // clic en bas de liste, la nouvelle page s'affiche hors de l'écran.
        section.scrollIntoView({ block: 'start', behavior: 'smooth' });
        section.focus({ preventScroll: true });
    };

    rendre();
    ul.after(nav);
}

function init() {
    document.querySelectorAll('.sgroup .scards').forEach((ul) => {
        const section = ul.closest('.sgroup');
        const cartes = [...ul.children].filter((el) => el.tagName === 'LI');
        if (cartes.length <= PAR_PAGE) return;
        construirePager(section, ul, cartes);
    });
}

document.addEventListener('DOMContentLoaded', init);
